import { Link } from 'react-router-dom';
import { categories } from '@/mocks/manga';

export default function Footer() {
  return (
    <footer className="bg-secondary-900">
      <div className="mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-bold text-background-50" style={{ fontFamily: 'var(--font-heading)' }}>韩漫之家</span>
            </div>
            <p className="text-sm text-secondary-300 leading-relaxed">
              韩漫之家是最优质的韩漫在线阅读平台，为您提供海量免费韩漫资源。每日更新，让您随时随地畅享精彩漫画世界。
            </p>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-secondary-300 hover:text-background-50 transition-colors">首页</Link>
              <Link to="/category/hot" className="text-sm text-secondary-300 hover:text-background-50 transition-colors">热门推荐</Link>
              <Link to="/category/new" className="text-sm text-secondary-300 hover:text-background-50 transition-colors">最新上架</Link>
              <Link to="/about" className="text-sm text-secondary-300 hover:text-background-50 transition-colors">关于我们</Link>
            </div>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门分类</h4>
            <div className="flex flex-col gap-2">
              {categories.filter(c => !['all', 'hot', 'new'].includes(c.slug)).slice(0, 5).map((cat) => (
                <Link key={cat.slug} to={`/category/${cat.slug}`} className="text-sm text-secondary-300 hover:text-background-50 transition-colors">{cat.name}漫画</Link>
              ))}
            </div>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系方式</h4>
            <div className="flex flex-col gap-2 text-sm text-secondary-300">
              <p>邮箱：contact@hanmanzhijia.com</p>
              <p>反馈：feedback@hanmanzhijia.com</p>
              <div className="flex items-center gap-3 mt-2">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-700 hover:bg-primary-500 transition-colors cursor-pointer" rel="nofollow">
                  <i className="ri-wechat-line text-background-50 text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-700 hover:bg-primary-500 transition-colors cursor-pointer" rel="nofollow">
                  <i className="ri-weibo-line text-background-50 text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-700 hover:bg-primary-500 transition-colors cursor-pointer" rel="nofollow">
                  <i className="ri-bilibili-line text-background-50 text-sm"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="border-t border-secondary-700 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-500">© 2026 韩漫之家 版权所有 | 本站内容仅供学习交流使用</p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-secondary-500 hover:text-background-50 transition-colors">用户协议</a>
            <a href="#" className="text-xs text-secondary-500 hover:text-background-50 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-secondary-500 hover:text-background-50 transition-colors">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}